import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getAllUsers, getAllUsersPaginated, getOrganizationUsersByOrgId, getUserInfo } from './cruds';


export const ACTION_TYPE_PARENT = 'organizationUser'

// NOTE: keep function name and thunk child name same
export const fetchAllUsers = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchAllUsers`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllUsers()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }

  }
)

export const fetchAllUsersPaginated = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchAllUsersPaginated`,
  async ({ payload, params, requestHeaders = undefined }: any, { rejectWithValue }) => {
    try {
      const response = await getAllUsersPaginated(payload, params, requestHeaders)
      return { data: response.data, responseHeaders: response.headers };
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

// * fetch organization users by organization ID
export const fetchOrganizationUsersByOrgId = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchOrganizationUsersByOrgId`,
  async ({ organizationPk, requestHeaders }: any, { rejectWithValue }) => {
    try {
      const response = await getOrganizationUsersByOrgId(organizationPk, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }

  }
)

export const fetchUserInfo = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchUserInfo`,
  async ({ name }: any, { rejectWithValue }) => {
    try {
      const response = await getUserInfo(name)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)
